/**
 * WordPress dependencies.
 */
/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';
import {Fragment,useState,useEffect} from '@wordpress/element';
import { IoIosHeartEmpty,IoMdRepeat} from "react-icons/io";
/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';
/**
 * Internal dependencies
 */
import InsSettings from './settings.js';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import { VayuBlocksUniqueId, VayuBlocksCssTextAlign, getResponsiveRangeValue, borderStyle, borderRadiusStyle, boxShadow, dimensions, VayuBlocksTypography, background } from "@vayu-blocks/global";
import { VayuBlockAdvanceStyle } from '@vayu-blocks/advance-panel/style.js';
import { MouseFollower } from '@vayu-blocks';
/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

export default function Edit(props) {

  const { attributes, setAttributes, clientId, isSelected } = props;

  const { mergedStyles, isHovered, handleMouseEnter, handleMouseLeave, hoverAnimationClass } = VayuBlockAdvanceStyle(attributes);
  
  const { id } = attributes;

  if ( ! id ) {
		setAttributes( { id: clientId } );
	}

  const omitBy = (object, condition) => (
		Object.fromEntries(
		  Object.entries(object).filter(([key, value]) => !condition(value))
		)
	  );

  VayuBlocksUniqueId({ 
          setAttributes: setAttributes, 
          clientId: clientId
        });
  
  const deviceView = VayuBlocksDevice(); 

  let isDesktop = deviceView === 'Desktop';
  let isTablet = deviceView === 'Tablet';
  let isMobile = deviceView === 'Mobile';

  let ColStyles;
  let productsPerPage;

  if ( isDesktop ) {
    productsPerPage = attributes.productShow?.Desktop || '6';
    ColStyles = { 
      '--grid-col': (attributes.productCol?.Desktop || '3'),
    }

  }
  if ( isTablet ) {
     productsPerPage = attributes.productShow?.Tablet || '6';
    ColStyles = { 
      '--grid-col': (attributes.productCol?.Tablet || '3'),
    }

  }
  if ( isMobile) {
    productsPerPage = attributes.productShow?.Mobile || '6';
    ColStyles = { 
      '--grid-col': (attributes.productCol?.Mobile || '1'),
    }

  }
  const [selectedCategory, setSelectedCategory] = useState('');
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [noproduct, setNoproduct] = useState();
  const homeUrl = vayublock.homeUrl2;
  const [currentPage, setCurrentPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(true);

  let prdType = ''; 
  let prdOrderBy = '';
  let prdOrder = '';

  if (attributes.productType === 'sale') {
    prdType = '&on_sale=true';
  } else if (attributes.productType === 'featured') {
    prdType = '&featured=true';
  } else if (attributes.productType === 'manual') {
    // Fetch all products if no category is selected
    let manualProductParam = '';
    if (attributes.manualProduct && attributes.manualProduct.length > 0) {
      const selectedManualProduct = attributes.manualProduct.map((maualP) => maualP.value);
      manualProductParam = selectedManualProduct.join(',');
    }
    prdType = `&include=${manualProductParam}`;
  } else{
    prdType = ``;
  }

  //orderby
  if (attributes.productOrderby === 'date') {
    prdOrderBy = '&orderby=date';
  } else if (attributes.productOrderby === 'price') {
    prdOrderBy = '&orderby=price';
  } else if (attributes.productOrderby === 'popularity') {
    prdOrderBy = '&orderby=popularity';
  } else if (attributes.productOrderby === 'rating') {
    prdOrderBy = '&orderby=rating';
  } else if (attributes.productOrderby === 'menu-order') {
    prdOrderBy = '&orderby=menu_order';
  } 
  
  // order
  if (attributes.productOrder === 'asc') {
    prdOrder = '&order=asc';
  } else if(attributes.productOrder === 'desc') {
    prdOrder = '&order=desc';
  } 

  // product exclude
  let excludeProductParam = '';
  if (attributes.excludeProduct && attributes.excludeProduct.length > 0) {
    const selectedExcludeProduct = attributes.excludeProduct.map((excldeP) => excldeP.value);
    excludeProductParam = `&exclude=${selectedExcludeProduct.join(',')}`;
  }

  //stock status
  let stockParam = '';
  if (attributes.stockStatus && attributes.stockStatus.length > 0) {
    stockParam = `&stock_status=${attributes.stockStatus}`;
  }


  // useEffect hook to fetch products based on selected category
  useEffect(() => {
    if (selectedCategory) {
      setIsLoading(true);
      // Fetch products based on selected category
      fetch(`${homeUrl}/wp-json/wc/store/v1/products?category=${selectedCategory}&per_page=${productsPerPage}${prdType}${prdOrderBy}${prdOrder}${excludeProductParam}${stockParam}`)
        .then((response) => response.json())
        .then((data) => {
          setProducts(data);
          setIsLoading(false);
          setHasNextPage(data.length === productsPerPage);
        })
        .catch((error) => {
          console.error('Error fetching products:', error);
        });
    } else {
      setIsLoading(true);
      // Fetch all products if no category is selected
      let categoryParam="";
      if (attributes.productCategories && attributes.productCategories.length > 0) {
        const selectedCategories = attributes.productCategories.map((category) => category.value);
        categoryParam = `&category=${selectedCategories.join(',')}`;
      }
      fetch(`${homeUrl}/wp-json/wc/store/v1/products?&per_page=${productsPerPage}${categoryParam}${prdType}${prdOrderBy}${prdOrder}${excludeProductParam}${stockParam}`)
        .then((response) => response.json())
        .then((data) => {
          setProducts(data);
          setIsLoading(false);
          setHasNextPage(data.length === productsPerPage);
          if (data.length === 0) {
            setNoproduct(true);
          } else {
            setNoproduct(false);
          }
        })
        .catch((error) => {
          console.error('Error fetching products:', error);
        });
    }
  }, [selectedCategory, currentPage, productsPerPage, attributes.productCategories, prdType, prdOrderBy, prdOrder, excludeProductParam, stockParam]);
  // Event handler for tab click
  const handleTabClick = (categoryId) => {
    setSelectedCategory(categoryId);
    setCurrentPage(1);
  };
   
  // Show star rating
  const RatingStars = ({ rating, maxRating = 5, filledColor = 'gold', emptyColor = 'lightgray' }) => {
    const starCount = Math.min(Math.floor(rating), maxRating);
    return (
      <div>
        {Array(maxRating)
          .fill()
          .map((_, index) => (
            <span key={index} style={{ color: index < starCount ? filledColor : emptyColor }}>
              &#9733;
            </span>
          ))}
      </div>
    );
  };

  let alignment;

  const deviceAttributeMap = {
    desktop: {
      elementGap: getResponsiveRangeValue(attributes.elementGap, 'Desktop'),
      alignment : attributes.tabAlign.Desktop,
      saleBrdradius: getResponsiveRangeValue(attributes.saleBrdradius, 'Desktop'),
      
    },
    
    tablet: {
      elementGap: getResponsiveRangeValue(attributes.elementGap, 'Tablet'),
      alignment : attributes.tabAlign.Tablet,
      saleBrdradius: getResponsiveRangeValue(attributes.saleBrdradius, 'Tablet'),
     
    },
    mobile: {
     elementGap: getResponsiveRangeValue(attributes.elementGap, 'Mobile'),
     alignment : attributes.tabAlign.Mobile,
     saleBrdradius: getResponsiveRangeValue(attributes.saleBrdradius, 'Mobile'),
      
    }
  };
  const deviceType = isDesktop ? 'desktop' : isTablet ? 'tablet' : 'mobile';
  
  // title setting
  const TitleTag = attributes.prouctTitleTag || 'h3';

  let ProductStyles;
  let tabOption;

  const ElementGap = deviceAttributeMap[deviceType].elementGap;
  const Tabalignment = deviceAttributeMap[deviceType].alignment;
  const saleBrdradius = deviceAttributeMap[deviceType].saleBrdradius;

  //tab option and settings
  const [isHoveredTab, setIsHoveredTab] = useState(false);
  tabOption = {
     ...VayuBlocksTypography(attributes.tabTypography, deviceView),
     padding:dimensions(attributes.tabPadding, deviceView),
     margin:dimensions(attributes.tabMargin, deviceView),
     ...boxShadow(attributes.tabShadow, deviceView),
     ...borderStyle(attributes.tabBorder, deviceView),
     ...borderRadiusStyle(attributes.tabRadius, deviceView),

  }

  const hovertabOption = {
  ...boxShadow(attributes.tabShadowHover, deviceView, attributes.tabShadow),
  ...borderStyle(attributes.tabBorderHover, deviceView, attributes.tabBorder),
  ...borderRadiusStyle(attributes.tabRadiusHover, deviceView, attributes.tabRadius),

  };

  const tabOptionStyles = omitBy(hovertabOption, value => value === undefined || value === null);
  
  // new option
  let productElement;
  productElement = {
  padding: dimensions(attributes.productPadding, deviceView),
  ...VayuBlocksCssTextAlign(attributes.productAlign,deviceView),
  };

let buttonOption;

const [isHoveredbuttonOption, setIsHoveredbuttonOption] = useState(false);
  buttonOption = {
  padding: dimensions(attributes.buttonSpacing, deviceView),
  ...boxShadow(attributes.buttonShadow, deviceView),
  ...borderStyle(attributes.buttonBorder, deviceView),
  ...borderRadiusStyle(attributes.buttonRadius, deviceView),
  };
  const hoverproductbuttonOption = {
  ...boxShadow(attributes.buttonShadowHover, deviceView, attributes.buttonShadow),
  ...borderStyle(attributes.buttonBorderHover, deviceView, attributes.buttonBorder),
  ...borderRadiusStyle(attributes.buttonRadiusHover, deviceView, attributes.buttonRadius),
  };

const productbuttonOptionHoverStyles = omitBy(hoverproductbuttonOption, value => value === undefined || value === null);

   let customwidth;

    if( attributes.widthType =='inlinewidth' ) {

		customwidth = {
             
	    '--display':'inline-flex',
			
		};

	}
  
  const boxborder = attributes.productboxBorder?.[deviceView] || {};
  const boxborderHvr = attributes.productboxBorderHover?.[deviceView] || {};

  const productBoxBorderVars = {
  '--productBox-top-style': boxborder?.top?.style ?? boxborder?.style ?? boxborder?.style,
  '--productBox-right-style': boxborder?.right?.style ?? boxborder?.style ?? boxborder?.style,
  '--productBox-bottom-style': boxborder?.bottom?.style ?? boxborder?.style ?? boxborder?.style,
  '--productBox-left-style': boxborder?.left?.style ?? boxborder?.style ?? boxborder?.style,

  '--productBox-top-width': boxborder?.top?.width ?? boxborder?.width  ?? boxborder?.width ,
  '--productBox-right-width': boxborder?.right?.width ?? boxborder?.width  ?? boxborder?.width ,
  '--productBox-bottom-width': boxborder?.bottom?.width  ?? boxborder?.width  ?? boxborder?.width ,
  '--productBox-left-width': boxborder?.left?.width  ?? boxborder?.width  ?? boxborder?.width ,

  '--productBox-top-color': boxborder?.top?.color ?? boxborder?.color  ?? boxborder?.color ,
  '--productBox-right-color': boxborder?.right?.color ?? boxborder?.color  ?? boxborder?.color ,
  '--productBox-bottom-color': boxborder?.bottom?.color  ?? boxborder?.color  ?? boxborder?.color ,
  '--productBox-left-color': boxborder?.left?.color  ?? boxborder?.color  ?? boxborder?.color ,
};

const productBoxBorderVarsHvr = {
  '--productBox-top-style-hvr': boxborderHvr?.top?.style ?? boxborderHvr?.style ?? '',
  '--productBox-right-style-hvr': boxborderHvr?.right?.style ?? boxborderHvr?.style ?? '',
  '--productBox-bottom-style-hvr': boxborderHvr?.bottom?.style ?? boxborderHvr?.style ?? '',
  '--productBox-left-style-hvr': boxborderHvr?.left?.style ?? boxborderHvr?.style ?? '',

  '--productBox-top-width-hvr': boxborderHvr?.top?.width ?? boxborderHvr?.width ?? '',
  '--productBox-right-width-hvr': boxborderHvr?.right?.width ?? boxborderHvr?.width ?? '',
  '--productBox-bottom-width-hvr': boxborderHvr?.bottom?.width ?? boxborderHvr?.width ?? '',
  '--productBox-left-width-hvr': boxborderHvr?.left?.width ?? boxborderHvr?.width ?? '',

  '--productBox-top-color-hvr': boxborderHvr?.top?.color ?? boxborderHvr?.color ?? '',
  '--productBox-right-color-hvr': boxborderHvr?.right?.color ?? boxborderHvr?.color ?? '',
  '--productBox-bottom-color-hvr': boxborderHvr?.bottom?.color ?? boxborderHvr?.color ?? '',
  '--productBox-left-color-hvr': boxborderHvr?.left?.color ?? boxborderHvr?.color ?? '',
};

const productboxRadius = attributes.productboxRadius?.[deviceView] || {};
const productboxRadiusHvr = attributes.productboxRadiusHover?.[deviceView] || {};

const productBoxRadiusVars = {
  '--productBox-top-left-radius': productboxRadius?.topLeft ?? '',
  '--productBox-top-right-radius': productboxRadius?.topRight ?? '',
  '--productBox-bottom-right-radius': productboxRadius?.bottomRight ?? '',
  '--productBox-bottom-left-radius': productboxRadius?.bottomLeft ?? '',
};

const productBoxRadiusVarsHvr = {
  '--productBox-top-left-radius-hvr': productboxRadiusHvr?.topLeft ?? '',
  '--productBox-top-right-radius-hvr': productboxRadiusHvr?.topRight ?? '',
  '--productBox-bottom-right-radius-hvr': productboxRadiusHvr?.bottomRight ?? '',
  '--productBox-bottom-left-radius-hvr': productboxRadiusHvr?.bottomLeft ?? '',
};


const boxshadow = attributes.productboxShadow?.[deviceView]?.elements || {};
const boxshadowHvr = attributes.productboxShadowHover?.[deviceView]?.elements || {};

const productBoxShadowCss = {
  '--productBox-box-shadow': `${boxshadow?.inset === 'inset' ? 'inset' : ''} ${boxshadow?.offsetX ?? '0px'} ${boxshadow?.offsetY ?? '0px'} ${boxshadow?.blur ?? '0px'} ${boxshadow?.spread ?? '0px'} ${boxshadow?.color ?? '#000'}`.trim(),
};

const productBoxShadowCssHvr = {
  '--productBox-box-shadow-hvr': `${boxshadowHvr?.inset === 'inset' ? 'inset' : ''} ${boxshadowHvr?.offsetX ?? '0px'} ${boxshadowHvr?.offsetY ?? '0px'} ${boxshadowHvr?.blur ?? '0px'} ${boxshadowHvr?.spread ?? '0px'} ${boxshadowHvr?.color ?? '#000'}`.trim(),
};

/***************/
// Tab option
/****************/



  ProductStyles = {

    ...customwidth,

    '--title-color': attributes.productTitleColor,
    '--title-color-hvr': attributes.productTitleColorHvr,
   
    '--cat-color': attributes.catTxtColor,
    '--cat-color-hvr': attributes.catTxtColorHvr,
    
    '--price-color': attributes.priceColor,
    '--price-color-del': attributes.priceDelColor,
    
    '--button-color': attributes.buttonTxtClr,
    '--button-bg-color': attributes.buttonBgClr,
    '--button-border-color': attributes.buttonBrdrClr,
    '--button-hvr-color': attributes.buttonTxtClrHvr,
    '--button-bg-hvr-color': attributes.buttonBgClrHvr,
    '--button-border-hvr-color': attributes.buttonBrdrClrHvr,
    '--button-border-type': attributes.buttonBrdrType,

    '--sale-color':attributes.saleClr,
    '--sale-bg-color':attributes.saleBgClr,

    '--post-meta-color':attributes.postMetaClr,
    '--post-meta-bg-color':attributes.postMetaBgClr,
    '--post-meta-hvr-color':attributes.postMetaHvrClr,
    '--post-meta-bg-hvr-color':attributes.postMetaBgHvrClr,

    '--productBox-bg':attributes.productboxClr,
    '--productBox-hvr-bg':attributes.productboxHvrClr,
    ...productBoxBorderVars,
    ...productBoxBorderVarsHvr,
    ...productBoxRadiusVars,
    ...productBoxRadiusVarsHvr,
    ...productBoxShadowCss,
    ...productBoxShadowCssHvr,

  '--tab-txt':attributes.tabColor,
  '--tab-hvr-txt':attributes.tabColorHvr,
  '--tab-bg':attributes.tabBgColor,
  '--tab-hvr-bg':attributes.tabBgColorHvr,

  }
  
  let overlayBackground;
  let overlayBackgroundHover;

  overlayBackground = {
            ...background(attributes.overlaybackground),
        };
        
  overlayBackgroundHover = {
            ...background(attributes.overlaybackgroundHover),
        };

  const filteredHoverStyles = omitBy( overlayBackgroundHover, value => value === undefined || value === null);

	const overlayStyle = {
				...overlayBackground,
        ...(isHovered ? filteredHoverStyles : {}),
	};

  let containerClasses = classnames({
				
    "th-hide-desktop": attributes.responsiveTogHideDesktop,
    "th-hide-tablet": attributes.responsiveTogHideTablet,
    "th-hide-mobile": attributes.responsiveTogHideMobile,

    });


  const style = omitBy({
    ...mergedStyles,
    ...ColStyles,
    ...ProductStyles,
  }, x => x?.includes?.( 'undefined' ));

  const blockProps = useBlockProps({
    id:attributes.uniqueId,
    className:containerClasses,
    style,
  });

  const productBlockProps = {
		...blockProps,
		onMouseEnter: handleMouseEnter,
		onMouseLeave: handleMouseLeave,
	};

let salebrdstyle;

if (attributes.saleStyle === 'style1') {
  salebrdstyle = { borderRadius: saleBrdradius ? saleBrdradius : '0px' };
} else {
  salebrdstyle = undefined; // or {}
}

  return ( 
    <Fragment>
    {isSelected &&
		<InsSettings {...props} />	
    }
    <div {...productBlockProps} >   
    <div className="th-product-block-wrapper">
			<div
				className="wp-block-th-blocks-overlay"
				style={overlayStyle}
			/>
        <>
        {attributes.showTab && (
          <div className="th-product-block-cat-filter">
            <ul className="category-tabs" style={{ justifyContent: Tabalignment }}>
              {attributes.productCategories.map((category) => (
                <li
                  key={category.value}
                  className={selectedCategory === category.value ? 'active' : ''}
                  onClick={() => handleTabClick(category.value)}
                  style={{
                    ...tabOption,
                    ...(isHoveredTab ? tabOptionStyles : {}),
                  }}
                  onMouseEnter={() => setIsHoveredTab(true)}
                  onMouseLeave={() => setIsHoveredTab(false)}
                  >
                  {category.label}
                </li>
              ))}
            </ul>
          </div>
        )}
          <div className="th-product-block-product-content">
            <div className="th-product-block-product-item-wrap" style={{ gap: ElementGap }}>
             {isLoading && (
              <div className="th-block-loader">Loading...</div>
             )}

             {noproduct && (
              <p>No Product</p>
             )}
               {products.map((product, index) => (
                  
                <div className={`th-product-item ${hoverAnimationClass}`} key={product.id}>
                  <div className="th-product-block-content-wrap" style={productElement}>
                  {attributes.template.map((element) => {
                      switch (element) {
                        case 'image':
                          return (
                            attributes.displayFeaturedImage && (
                              
                            <div className={`th-product-image ${attributes.imageStyle}`}>
                              {product.on_sale && attributes.showSale == true &&
                              <div style={salebrdstyle} className={`th-product-sale ${attributes.saleStyle} ${attributes.saleDesign} ${attributes.salePosition}`}>
                               {attributes.saleDesign =='saletext' &&
                               <span className="discount-percentage">{attributes.saleText}</span>
                               }
                               {attributes.saleDesign =='saledigit' && product.prices.regular_price &&  product.prices.sale_price && (
                                <span className="discount-percentage">
                                  {Math.round(
                                    ((product.prices.regular_price - product.prices.sale_price) /
                                    product.prices.regular_price) *
                                      100
                                  )}
                                  {__( '%', 'vayu-blocks' )}
                                </span>
                              )}
                              </div>
                              }
                      {product.images && product.images[0] && product.images[0].thumbnail ? (
                        attributes.imageStyle === 'swapin' && product.images[1] && product.images[1].thumbnail ? (
                            <>
                                <img src={product.images[0].thumbnail} alt={product.name} />
                                <img src={product.images[1].thumbnail} className="th-swap" alt={product.name} />
                            </>
                        ) : (
                            <img src={product.images[0].thumbnail} alt={product.name} />
                        )
                    ) : null}

                                <div className="th-product-meta">
                                {attributes.showWishlist == true &&
                                  <div className="th-icons th-wishlist-button">
                                 <IoIosHeartEmpty></IoIosHeartEmpty>
                                 </div>
                                }
                                 {attributes.showCompare == true &&
                                 <div className="th-icons th-compare-button">
                                 <IoMdRepeat></IoMdRepeat>
                                 </div>
                                }
                                 
                              </div>
                            </div>
                            )
                          );
                        case 'category':
                          return (
                            attributes.displayCategory && (
                            <div className="th-product-cat">
                              {product.categories.map((category) => (
                                <a style = {VayuBlocksTypography(attributes.catTypography, deviceView)} key={category.id} href={category.link}>
                                  {category.name}
                                </a>
                              ))}
                            </div>
                            )
                          );
                        case 'title':
                          return (
                            attributes.displayTitle && (
                            <TitleTag className="th-product-title">
                              <a style = {VayuBlocksTypography(attributes.titleTypography, deviceView)} key={product.id} href={product.permalink}>
                                {product.name}
                              </a>
                            </TitleTag>
                            )
                          );
                        case 'price':
                          return (
                            attributes.displayPrice && (
                            <div
                              className="th-product-price"
                              dangerouslySetInnerHTML={{ __html: product.price_html }}
                              style = {VayuBlocksTypography(attributes.priceTypography, deviceView)}
                            ></div>
                            )
                          );
                        case 'rating':
                          return (
                            attributes.displayRating && (
                              <div className="th-product-rating" style = {VayuBlocksTypography(attributes.ratingTypography, deviceView)}>
                               {attributes.hideRating === true && product.average_rating !== '0' && ( 
                                  <RatingStars
                                    rating={parseFloat(product.average_rating)}
                                    maxRating={5}
                                    filledColor={attributes.ratingColor || 'gold'}
                                    emptyColor={attributes.emptyratingColor}
                                  />
                                  )}
                              </div>
                            )
                          );
                        case 'button':
                          return attributes.displayButton && (
                          <div
                          style={{
                            ...buttonOption,
                            ...(isHoveredbuttonOption ? productbuttonOptionHoverStyles : {}),
                            ...VayuBlocksTypography(attributes.buttonTypography, deviceView)
                          }}
                          onMouseEnter={() => setIsHoveredbuttonOption(true)}
                          onMouseLeave={() => setIsHoveredbuttonOption(false)}
                          className="th-product-btn"
                        >{product.add_to_cart.text}</div>
                          );
                        default:
                          return null; 
                      }
                    })}
                    </div>
                </div>
              ))}
            </div>
            {attributes.showNavs && !noproduct && (
            <div className="th-pagination">
              <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
                <span className="dashicons dashicons-arrow-left-alt2"></span>
              </button>
              <button disabled={!hasNextPage} onClick={() => setCurrentPage(currentPage + 1)}>
                <span className="dashicons dashicons-arrow-right-alt2"></span>
              </button>
            </div>
           )}
          </div>
        </>
        <MouseFollower value={attributes.advFollower} clientId={clientId}/>
    </div>
    </div> 
    </Fragment>
  );
}